import { ref, reactive, toRefs, watch, computed, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import Cookies from 'js-cookie';
export default {
  name: 'EIUploadOnePic',
  components: {
    Plus
  },
  props: {
    action: {
      default: '',
      type: String
    },
    limit: {
      type: Number,
      default: 6
    },
    fileList: {
      default: function () {
        return [];
      },
      type: Array
    },
    type: {
      default: 'image',
      type: String
    },
    fileType: {
      default: '',
      type: String
    },
    uploadTip: {
      default: '',
      type: String
    }
  },
  emits: ['update:fileList', 'clearValidate'],
  setup(props, context) {
    watch(() => props.fileList, val => {
      state.url = '';
      // 重新初始化文件列表
      if (val && val.length > 0) {
        state.fileListAll = [];
        methods.initFileList();
      } else {
        state.fileListAll = [];
      }
    }, {
      deep: true
    });
    const state = reactive({
      url: '',
      fileListAll: [],
      baseUrl: `${window.g.imgUrlPrex}`,
      headers: {
        'Authorization': Cookies.get('accessToken')
      }
    });
    const fileName = computed(() => {
      return props.fileList[0]?.fileName;
    });
    // 调用初始化方法
    onMounted(() => {
      if (props.fileList || props.fileList.length > 0) {
        methods.initFileList();
      }
    });
    const methods = reactive({
      // 将URL列表转换为fileList格式
      initFileList() {
        props.fileList.forEach(url => {
          state.fileListAll.push({
            name: url.split('/').pop(),
            url: state.baseUrl + url,
            response: {
              code: 0,
              data: {
                name: url.split('/').pop(),
                url: url
              }
            }
          });
        });
      },
      // 删除
      handleRemove(uploadFile, uploadFiles) {
        let imgData = uploadFiles.map(item => {
          if (item.response.code == 0) {
            return item.response.data.url;
          }
        });
        context.emit('update:fileList', imgData);
        context.emit('clearValidate');
      },
      // 上传文件格式一律转为小写
      commonHandleCheck(val) {
        let testmsg = val.substring(val.lastIndexOf('.') + 1);
        testmsg && (testmsg = testmsg.toLowerCase());
        return testmsg;
      },
      handleExceed() {
        ElMessage.warning(`最多只能上传${props.limit}张图片!`);
      },
      handleAvatarSuccess(res, file) {
        let imgData = state.fileListAll.map(item => {
          console.log(item, 'item--');
          if (item.response.code == 0) {
            return item.response.data.url;
          }
        });
        console.log(imgData, 'imgData--');
        context.emit('update:fileList', imgData);
        context.emit('clearValidate');
      },
      beforeAvatarUpload(file) {
        let testmsg = methods.commonHandleCheck(file.name);
        const isJPEG = testmsg === 'jpeg';
        const isJPG = testmsg === 'jpg';
        const isPNG = testmsg === 'png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG && !isPNG && !isJPEG) {
          ElMessage.error('上传图片只能是 JPG、JPEG、PNG格式!');
          return false;
        }
        if (!isLt2M && file.size == 0) {
          ElMessage.error('上传图片大小不能超过 2MB!');
          return false;
        }
        return isJPG || isPNG || isJPEG;
      }
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      fileName
    };
  }
};